import { createMongoAbility } from '@casl/ability';

export const appAbility = createMongoAbility([]);
export type AppRule = Parameters<(typeof appAbility)['update']>[0][number];
export default appAbility;
